import { IPrice } from 'services/api/entities';
import { PaymentInterval } from 'services/contexts/PricingContext/PricingProvider';

export const getMonthlyPrice = (priceList: IPrice[]) =>
  priceList.filter((p) => p.recurring.interval === PaymentInterval.MONTH)[0];

export const getYearlyPrice = (priceList: IPrice[]) =>
  priceList.filter((p) => p.recurring.interval === PaymentInterval.YEAR)[0];
